import { useCallback, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getSavedSearch, setSavedSearch } from 'helpers/searchStorage'

// Sozlamalardagi "Izlashga yozilgan ma'lumotlarni saqlab qolish" yoqilgan bo'lsa,
// sahifadagi izlash matnini saqlaydi va sahifaga qaytilganda tiklaydi.
//
// restore - saqlangan matn topilganda bir marta chaqiriladi (izlashni qayta ishga tushirish uchun).
// Qaytadi: save(value) - yozilgan matnni saqlash uchun funksiya.
function useSavedSearch(restore, storageKey) {
	const enabled = !!useSelector(state => state.settings?.saveSearch)
	const { pathname } = useLocation()
	const key = storageKey || pathname

	const restoreRef = useRef(restore)
	restoreRef.current = restore
	const restored = useRef(false)

	useEffect(() => {
		if (restored.current) return
		restored.current = true
		if (!enabled) return

		const saved = getSavedSearch(key)
		if (!saved) return

		// Sahifaning o'z boshlang'ich so'rovi (mount useEffect) birinchi ketishi uchun
		// izlashni keyingi navbatda ishga tushiramiz -- aks holda to'liq ro'yxat
		// izlash natijasini bosib ketishi mumkin.
		const timer = setTimeout(() => restoreRef.current(saved), 0)
		return () => clearTimeout(timer)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const save = useCallback((value) => {
		if (!enabled) return
		setSavedSearch(key, value)
	}, [enabled, key])

	return save
}

export default useSavedSearch
